/* 
    侧拉孙表区域组件
    created by: liyaoh 2019-06-04
*/
import React, { Component } from 'react';
import { connect } from "react-redux";
import { DragSource, DropTarget } from 'react-dnd';
import { updateSelectArea } from "Store/ZoneSetting/action";
import { removeSelectCardCls, subscribeSetActiveKey } from '../../events';
import BaseAreaItem from '../BaseAreaItem';
import platform from "Pub/js/platform";
const { PubSub } = platform;

const areaSource = {
    beginDrag(props) {
        if (!props.isImplement) {
            props.updateSelectArea(props.grandson); //拖拽时选中当前区域
            removeSelectCardCls(); //清空选中字段样式
        }
        return {
            id: props.grandson.pk_area,
            index: props.grandsonIndex,
            type: 'area',
            areaType: 'grandson', //用于区分区域还是孙表
        };
    },
};

const areaTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            props.onDrop(monitor);
        } else if (dragItem.from !== 'left') {
            const dragIndex = dragItem.index;
            const hoverIndex = props.grandsonIndex;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex || props.isImplement) {return;}

            props.onDragArea(dragIndex, hoverIndex);
            monitor.getItem().index = hoverIndex;
        }
    },
};
@DragSource('area', areaSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}))
//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
class GrandsonArea extends Component {

    componentDidMount() {
        this.pubsub = subscribeSetActiveKey(this.props.grandson, this.props.onTabChange);
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub); //移除订阅
    }
    render() {
        const {
            areaClassName,
            grandson,
            isActive,
            isTile,
            renderCard,
            contentVisible,
            renderHeader,
            onClick,
            connectDragSource,
            connectDropTarget,
            areaHide,
        } = this.props;
        return !areaHide[grandson.pk_area] && connectDragSource(
            connectDropTarget(
                <div type="ncdiv" fieldid={`${grandson.code}_area`} className={areaClassName + ` search-area-${String(grandson.code).replace(/\.|\&|\#/g, '') || 'unknow'}`} onClick={onClick}>
                    <BaseAreaItem
                        isShow={contentVisible}
                        isTile={isTile}
                        areaItem={grandson}
                        renderHeader={renderHeader}
                        renderCard={renderCard}
                        activeTabKey={this.props.activeTabKey}
                        onAreaClick={this.props.onAreaClick}
                        onTabChange={this.props.onTabChange}
                        onTabPaneDrop={this.props.onTabPaneDrop}
                        multiOptions={this.props.multiOptions}
                    />
                </div>,
            ),
        );
    }
}

export default connect(
    state => ({
        isImplement: state.zoneSettingData.isImplement,
        areaHide: state.zoneSettingData.areaHide,
    }),
    { updateSelectArea },
)(GrandsonArea);